<template>
  <div class="setComponent">
    <!-- 提示栏 -->
    <el-alert
      style="margin:15px 0;"
      :title="$i18n.t('wm_lang_0eeee5')"
      :closable="false"
      type="info">
    </el-alert>
    <!-- 表单 -->
    <el-form :model="ruleForm" ref="ruleForm" label-width="0" class="form-setting" size="medium">
      <el-form-item>
        <el-button type="primary" @click="addRules">{{$t("wm_lang_html_f10ed4")}}</el-button>
        <a @click="logRules" class="float-r" style="text-decoration:underline;">{{$t("wm_lang_html_882106")}}</a>
      </el-form-item>
      <!-- 表格 -->
      <el-form-item>
      <el-table
        size="medium"
        :row-class-name="tableRowClassName"
        :data="tableData"
        style="width: 100%">
        <!--<el-table-column-->
          <!--type="selection"-->
          <!--width="45">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--label=this.$i18n.t('wm_lang_df4b35')>-->
          <!--<template slot-scope="scope">-->
            <!--<span style="margin-left: 10px">{{ scope.row.ruleName }}</span>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column
          :label="$i18n.t('wm_lang_df4b35')">
          <template slot-scope="scope">
            <p style="color:#00102f"><b>{{ scope.row.ruleName }}</b></p>
            <p style="color:#24324c" v-for="(item, index) in scope.row.ruleConditionDescribe"><span v-if="index === 0"><b>{{$t("wm_lang_html_f12e4a")}} </b></span><span v-if="index !== 0"><b>{{$t("wm_lang_html_1dea3a")}} </b></span><span class="cutout max-80auto ib pr-1" :title="(item)">{{ item }}</span></p>
            <p style="color:#24324c" v-for="(item, index) in scope.row.ruleExecuteDescription" :key="index"><span v-if="index === 0"><b>{{$t("wm_lang_html_857cee")}} </b></span>{{ item }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$i18n.t('wm_lang_3fea7c')"
          width="160">
          <template slot-scope="scope">
          <el-switch :value="scope.row.status === statusEnable" @change="changeRuleStatus(scope.row.filterId, $event)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_2b6bc0')"
          width="160">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="editRules(scope.row.filterId)">{{$t("wm_lang_html_8347a9")}}</el-link>
            <el-link type="danger" :underline="false" @click="deleteRules(scope.row.filterId)">{{$t("wm_lang_html_2f4aad")}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          fixed="right"
          :label="$i18n.t('wm_lang_6367e7')"
          width="160">
          <template slot-scope="scope">
          <a href="javascript:;" class="s_btn" v-if="scope.row.index !== 0" @click="sortChange(scope.row.filterId, 'up')"><i class="el-icon-caret-top"></i></a>
          <a href="javascript:;" class="s_btn" v-if="scope.row.index !== tableData.length - 1" @click="sortChange(scope.row.filterId, 'down')"><i class="el-icon-caret-bottom"></i></a>
          </template>
        </el-table-column>
      </el-table>
      </el-form-item>
    </el-form>

    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
export default {
  name: 'classificationRules',
  data () {
    return {
      statusEnable: xmail.enums.AccountFilterRuleStatus.ENABLE,
      // 表格
      tableData: [],
      // 表单
      ruleForm: {
        //
      },
      rules: {
        //
      }
    }
  },
  mounted() {
    this.viewRulesList();
  },
  methods: {
    // 表单
    logRules() {
      this.$router.push({name: 'rulesLog'});
    },
    addRules() {
      if(this.tableData.length >= 100) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_e0b014')+'100'+this.$i18n.t('wm_lang_930882')
        });
        return;
      }
      this.$router.push({name: 'addRules'});
      this.$EventBus.$emit("updateBreadcrumb", {setBreadcrumb: this.$i18n.t('wm_lang_8e16eb')+'###'+this.$i18n.t('wm_lang_f10ed4')});
    },
    editRules(id) {
      this.$router.push({name: 'addRules', params: {id: id}});
      this.$EventBus.$emit("updateBreadcrumb",{setBreadcrumb: this.$i18n.t('wm_lang_8e16eb')+'###'+this.$i18n.t('wm_lang_84bef0')});
    },
    deleteRules(id) {
      this.$confirm(this.$i18n.t('wm_lang_a53c6f'), this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Filter.delFilterInfoParamBuilder();
          pm.filterId = id;
          api.Filter.delFilterInfo(pm, function (res) {
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_0007d1')
              });
              self.viewRulesList();
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        //
      });
    },
    changeRuleStatus(id, $event) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Filter.updateFilterStatusParamBuilder();
        pm.filterId = id;
        pm.status = $event ? xmail.enums.AccountFilterRuleStatus.ENABLE : xmail.enums.AccountFilterRuleStatus.DISABLE;
        // console.log(pm);
        // return;
        api.Filter.updateFilterStatus(pm, function (res) {
          if(res.data.code === 0) {
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_69be67')
            });
            self.viewRulesList();
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    tableRowClassName({row, rowIndex}) {
      //行索引放进row
      row.index = rowIndex;
    },
    sortChange(id, type) {
      let changeType = '';
      if(type === 'up'){
        changeType = xmail.enums.FilterPriorityType.MOVE_UP;
      } else {
        changeType = xmail.enums.FilterPriorityType.MOVE_DOWN;
      }
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Filter.changeFilterPriorityParamBuilder();
        pm.filterId = id;
        pm.filterPriorityType = changeType;
        api.Filter.changeFilterPriority(pm, function (res) {
          if(res.data.code === 0) {
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_358fd1')
            });
            self.viewRulesList();
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    viewRulesList() {
      let self = this;
      (function (api, enums, pms) {
        api.Filter.queryMailAccountFilterDescribe({}, function (res) {
          console.log(res.data)
          if(res.data.code === 0) {
            self.tableData = res.data.data;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/classificationRules.vue